import React from 'react';

interface VesselInfoFormProps {
  vesselName: string;
  callSign: string;
  imoNumber: string;
  vesselLocation: string;
  vesselFlag: string;
  onVesselNameChange: (value: string) => void;
  onCallSignChange: (value: string) => void;
  onImoNumberChange: (value: string) => void;
  onVesselLocationChange: (value: string) => void;
  onVesselFlagChange: (value: string) => void;
}

const VesselInfoForm: React.FC<VesselInfoFormProps> = ({
  vesselName, callSign, imoNumber, vesselLocation, vesselFlag,
  onVesselNameChange, onCallSignChange, onImoNumberChange,
  onVesselLocationChange, onVesselFlagChange,
}) => (
  <div className="card">
    <div className="p-4 border-b border-gray-200">
      <h2 className="text-lg font-semibold text-gray-900">F.06.03.02 CREW LIST - Vessel Information</h2>
    </div>
    <div className="p-4">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Vessel Name</label>
          <input
            type="text"
            value={vesselName}
            onChange={(e) => onVesselNameChange(e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm"
            placeholder="Enter vessel name..."
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Call Sign</label>
          <input
            type="text"
            value={callSign}
            onChange={(e) => onCallSignChange(e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm"
            placeholder="Enter call sign..."
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">IMO NO.</label>
          <input
            type="text"
            value={imoNumber}
            onChange={(e) => onImoNumberChange(e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm"
            placeholder="Enter IMO number..."
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Location</label>
          <input
            type="text"
            value={vesselLocation}
            onChange={(e) => onVesselLocationChange(e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm"
            placeholder="Enter location..."
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Flag</label>
          <input
            type="text"
            value={vesselFlag}
            onChange={(e) => onVesselFlagChange(e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm"
            placeholder="Enter flag..."
          />
        </div>
      </div>
    </div>
  </div>
);

export default VesselInfoForm;
